import HeaderLogo from '@/assets/logo_twm.png'
import PDFDivider from '@/components/ReportPDF/PDFDivider'
import { Image, Page, Text, View } from '@react-pdf/renderer'
import TaiwanDate from '../../TaiwanDateConvert'

const CoverPage = ({ reportData }) => {
  const { reprotDao, phishType } = reportData || {}
  const { companyName, campaignStartDate } = reprotDao || {}
  const service = phishType

  return (
    <Page
      dpi={140}
      size="A4"
      style={{ display: 'flex', fontFamily: 'Noto Sans', padding: '20px 10px 10px 10px' }}
    >
      <View style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
        <Image src={HeaderLogo} style={{ width: 800, height: 'auto', marginTop: 300, marginBottom: 200 }} />
      </View>
      <View style={{ fontSize: 30, alignItems: 'center', marginHorizontal: 40, marginTop: 40 }}>
        <Text style={{ fontSize: 60, marginTop: 40, lineHeight: 1.5 }}>
          社交工程<Text style={{ fontSize: 60 }}>{service}</Text>
          演練服務
        </Text>
        <Text style={{ fontSize: 60 }}>{'演練結果報告書'}</Text>

        <PDFDivider style={{ marginVertical: 20, backgroundColor: '#3366FF', height: 0.01, width: '80%', }} />
        <Text style={[{ fontSize: 48 }]}>{companyName}</Text>
        <Text style={[{ fontSize: 30, marginTop: 40, fontWeight: 'bold' }]}>
          {TaiwanDate({ reportDate: campaignStartDate })}
        </Text>
      </View>
    </Page>
  )
}

export default CoverPage
